import UserList from "../../components/account/UserList";

export default function Users() {
  return <UserList />;
}
